var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExaminationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9993 51.3333C15.1127 51.3333 4.66602 40.8865 4.66602 28C4.66602 15.1134 15.1127 4.66667 27.9993 4.66667C40.8859 4.66667 51.3327 15.1134 51.3327 28C51.3327 40.8865 40.8859 51.3333 27.9993 51.3333ZM27.9993 46.6667C38.3087 46.6667 46.666 38.3094 46.666 28C46.666 17.6907 38.3087 9.33334 27.9993 9.33334C17.69 9.33334 9.33268 17.6907 9.33268 28C9.33268 38.3094 17.69 46.6667 27.9993 46.6667ZM25.666 35H30.3327V39.6667H25.666V35ZM25.666 16.3333H30.3327V30.3333H25.666V16.3333Z",
    fill: "#FAAC9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExaminationIcon);
export default __webpack_public_path__ + "static/media/examinationIcon.381f344d316ea90a492221e35904570f.svg";
export { ForwardRef as ReactComponent };